(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireff32"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireff32"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2KVzz", function(module, exports) {
parcelRequire("3Jbcy");
parcelRequire("hFBKs");

});
parcelRegister("3Jbcy", function(module, exports) {
parcelRequire("gNFX6");

var $i8aF5 = parcelRequire("i8aF5");

var $cc2Az = parcelRequire("cc2Az");
let $2b6e4371694c44b7$var$headerHeight = parseFloat(document.documentElement.style.getPropertyValue("--header-height"));
let $2b6e4371694c44b7$var$lastHeaderPosition;
let $2b6e4371694c44b7$var$newHeaderPosition;
const $2b6e4371694c44b7$var$hideHeaderOnScroll = ()=>{
    $2b6e4371694c44b7$var$lastHeaderPosition = window.scrollY;
    (0, $i8aF5.addClassItem)(".header", "scroll");
    if ($2b6e4371694c44b7$var$headerHeight - 50 < $2b6e4371694c44b7$var$lastHeaderPosition && $2b6e4371694c44b7$var$lastHeaderPosition > $2b6e4371694c44b7$var$newHeaderPosition) {
        (0, $i8aF5.addClassItem)(".header", "hide");
        (0, $i8aF5.addClassItem)(".header", "scroll");
    } else if ($2b6e4371694c44b7$var$newHeaderPosition > $2b6e4371694c44b7$var$lastHeaderPosition) (0, $i8aF5.removeClassItem)(".header", "hide");
    if ($2b6e4371694c44b7$var$lastHeaderPosition < $2b6e4371694c44b7$var$headerHeight) (0, $i8aF5.removeClassItem)(".header", "scroll");
    $2b6e4371694c44b7$var$newHeaderPosition = $2b6e4371694c44b7$var$lastHeaderPosition;
};
const $2b6e4371694c44b7$var$throttleHideHeader = (0, $cc2Az.default)(()=>{
    $2b6e4371694c44b7$var$hideHeaderOnScroll();
}, 250);
window.addEventListener("scroll", $2b6e4371694c44b7$var$throttleHideHeader);
$2b6e4371694c44b7$var$throttleHideHeader();

});
parcelRegister("gNFX6", function(module, exports) {

$parcel$export(module.exports, "_classList", function () { return $c3b1c3ccd134fffe$export$5ccb867f293e3c4c; });
$parcel$export(module.exports, "_add", function () { return $c3b1c3ccd134fffe$export$eb19ebbec1ff9510; });
$parcel$export(module.exports, "_remove", function () { return $c3b1c3ccd134fffe$export$7be779bc7f76622c; });
$parcel$export(module.exports, "_toggle", function () { return $c3b1c3ccd134fffe$export$4b515c6f72c0fb7e; });
$parcel$export(module.exports, "_querySelector", function () { return $c3b1c3ccd134fffe$export$242934abc2863db9; });
const $c3b1c3ccd134fffe$export$c6742064fd272eef = "document", $c3b1c3ccd134fffe$export$5ccb867f293e3c4c = "classList", $c3b1c3ccd134fffe$export$eb19ebbec1ff9510 = "add", $c3b1c3ccd134fffe$export$7be779bc7f76622c = "remove", $c3b1c3ccd134fffe$export$4b515c6f72c0fb7e = "toggle", $c3b1c3ccd134fffe$export$7a240564ed1f29c7 = "querySelectorAll", $c3b1c3ccd134fffe$export$242934abc2863db9 = "querySelector";

});

parcelRegister("i8aF5", function(module, exports) {

$parcel$export(module.exports, "addClassItem", function () { return $d3313e8bfac2c304$export$6e6f8e21af33b231; });
$parcel$export(module.exports, "removeClassItem", function () { return $d3313e8bfac2c304$export$21b4674b9a6e7161; });

var $gNFX6 = parcelRequire("gNFX6");
const $d3313e8bfac2c304$export$6e6f8e21af33b231 = (item, className)=>{
    document[$gNFX6._querySelector](item)?.[$gNFX6._classList][$gNFX6._add](className);
};
const $d3313e8bfac2c304$export$21b4674b9a6e7161 = (item, className)=>{
    document[$gNFX6._querySelector](item)?.[$gNFX6._classList][$gNFX6._remove](className);
};
const $d3313e8bfac2c304$export$5401572fb47f69f8 = (item, className)=>{
    document[$gNFX6._querySelector](item)?.[$gNFX6._classList][$gNFX6._toggle](className);
};

});

parcelRegister("cc2Az", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e089d21dc42ae72$export$2e2bcd8739ae039; });
function $8e089d21dc42ae72$export$2e2bcd8739ae039(cb, delay = 1000) {
    let shouldWait = false;
    let waitingArgs;
    const timeoutFunc = ()=>{
        if (waitingArgs == null) shouldWait = false;
        else {
            cb(...waitingArgs);
            waitingArgs = null;
            setTimeout(timeoutFunc, delay);
        }
    };
    return (...args)=>{
        if (shouldWait) {
            waitingArgs = args;
            return;
        }
        cb(...args);
        shouldWait = true;
        setTimeout(timeoutFunc, delay);
    };
}

});


parcelRegister("hFBKs", function(module, exports) {
class $cdd38c0388b9fd28$export$2e2bcd8739ae039 {
    constructor(element){
        this.element = element;
        this.summary = element.querySelector("summary");
        this.content = element.querySelector("summary + div");
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.summary.addEventListener("click", (e)=>{
            this.onClick(e);
        });
    }
    onClick(e) {
        e.preventDefault();
        this.element.style.overflow = "hidden";
        if (this.isClosing || !this.element.open) this.open();
        else if (this.isExpanding || this.element.open) this.shrink();
    }
    shrink() {
        this.isClosing = true;
        const startHeight = `${this.element.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight}px`;
        if (this.animation) this.animation.cancel();
        this.animationElement(startHeight, endHeight);
        this.animation.onfinish = ()=>this.onAnimationFinish(false);
        this.animation.oncancel = ()=>this.isClosing = false;
    }
    open() {
        this.shrink();
        this.element.style.height = `${this.element.offsetHeight}px`;
        this.element.open = true;
        window.requestAnimationFrame(()=>this.expand());
    }
    animationElement(startHeight, endHeight) {
        this.animation = this.element.animate({
            height: [
                startHeight,
                endHeight
            ]
        }, {
            duration: 400,
            easing: "ease"
        });
    }
    onAnimationFinish(open) {
        this.element.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.element.style.height = this.element.style.overflow = "";
    }
    expand() {
        this.isExpanding = true;
        const startHeight = `${this.element.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
        if (this.animation) this.animation.cancel();
        this.animationElement(startHeight, endHeight);
        this.animation.onfinish = ()=>this.onAnimationFinish(true);
        this.animation.oncancel = ()=>this.isExpanding = false;
    }
}
[
    ...document.querySelectorAll("details")
].forEach((el)=>{
    new $cdd38c0388b9fd28$export$2e2bcd8739ae039(el);
});

});




parcelRequire("2KVzz");

})();
//# sourceMappingURL=destinations.043865e5.js.map
